import './LegalPage.css';

export default function Datenschutz() {
  return (
    <article className="legal">
      <span className="eyebrow">Rechtliches</span>
      <h1>Datenschutzerklärung</h1>
      <p className="legal__meta">Stand: {new Date().getFullYear()}</p>

      <h2>1. Verantwortlicher</h2>
      <p>
        Verantwortlich für die Datenverarbeitung auf dieser Website ist ProWick
        Immo. Kontaktdaten finden Sie im Impressum.
      </p>

      <h2>2. Erhebung und Verarbeitung personenbezogener Daten</h2>
      <p>
        Wir verarbeiten personenbezogene Daten nur, soweit dies zur Erbringung
        unserer Leistungen oder zur Beantwortung Ihrer Anfrage erforderlich ist.
      </p>

      <h2>3. Ihre Rechte</h2>
      <p>Ihnen stehen folgende Rechte zu:</p>
      <ul>
        <li>Auskunft über gespeicherte Daten</li>
        <li>Berichtigung unrichtiger Daten</li>
        <li>Löschung („Recht auf Vergessenwerden")</li>
        <li>Einschränkung der Verarbeitung</li>
        <li>Datenübertragbarkeit</li>
        <li>Widerspruch gegen die Verarbeitung</li>
      </ul>

      <h2>4. Cookies & Tracking</h2>
      <p>
        Diese Landingpage verwendet derzeit keine Tracking-Cookies. Sollte sich
        dies ändern, werden Sie vor dem Setzen um Einwilligung gebeten.
      </p>

      <h2>5. Kontakt</h2>
      <p>
        Fragen zum Datenschutz? Schreiben Sie uns an{' '}
        <a href="mailto:datenschutz@prowickimmo.at">datenschutz@prowickimmo.at</a>.
      </p>
    </article>
  );
}
